import { render } from "./tableTubeFLRow.vue?vue&type=template&id=52d1a63e"
import script from "./tableTubeFLRow.vue?vue&type=script&lang=js"
export * from "./tableTubeFLRow.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__